import React from "react";
import { motion } from "framer-motion";

const experiences = [
  {
    role: "Full-stack Developer",
    company: "PT Leaden Indonesia – Bandung, ID",
    companyUrl: "https://leaden.co.jp/",
    date: "Oct 2025 – Present",
    description: [
      "Engineered a comprehensive enterprise resource planning (ERP) and supply chain system, centralizing manufacturing, warehousing, and distribution workflows to significantly enhance operational efficiency.",
      "Leveraged strong accounting background to develop core financial modules including invoicing, job order costing, and asset management, ensuring highly accurate cost of goods sold (COGS) calculation and preventing operational cost leakages.",
      "Architected automated data pipelines and utilized advanced Excel financial modeling to process massive datasets, significantly streamlining cross-departmental reporting and reducing monthly reconciliation time by over 50%.",
      "Played a pivotal role in successfully establishing the company as a Bonded Zone (Kawasan Berikat) by architecting a highly structured, audit-ready ERP data foundation and seamlessly integrating it with the government's Customs (CEISA) network."
    ],
  },
  {
    role: "Support Engineer (Web & IoT)",
    company: "PT Quantum Prima Solusi – Alam Sutera, Tangerang, Indonesia",
    companyUrl: "https://quantumindo.com/",
    date: "Apr 28, 2025 – Aug 31, 2025",
    description:
      "Responsible for system stability, API documentation, backend debugging, remote monitoring, and providing technical support to partners.",
  },
  {
    role: "Intern – Information System (SISAPARA)",
    company:
      "Dinas Pemuda dan Olahraga Kota Bandung (DISPORA) – Bandung, Indonesia",
    companyUrl:
      "https://www.bandung.go.id/city-directory/info/257/dinas-pemuda-dan-olahraga",
    date: "Apr 14, 2025 – Jun 31, 2025",
    description:
      "Contributed to the design, development, and implementation of the SISAPARA information system.",
  },
  {
    role: "Co-Assistant Lecturer – Web 2: Fundamentals",
    company: "Institut Digital Ekonomi LPKIA – Bandung, Indonesia",
    companyUrl: "https://lpkia.ac.id/",
    date: "2024",
    description:
      "Assisted lecturers and students in conducting Web 2: Fundamentals practical sessions.",
  },
  {
    role: "Co-Assistant Lecturer – Web 3: Laravel Framework",
    company: "Institut Digital Ekonomi LPKIA – Bandung, Indonesia",
    companyUrl: "https://lpkia.ac.id/",
    date: "2024",
    description:
      "Provided support in practical sessions for Web 3: Laravel Framework, helping both lecturers and students.",
  },
  {
    role: "Founder / Fullstack Developer",
    company: "FARD Software Development – Bandung, Indonesia",
    companyUrl: "https://fard.github.io",
    date: "Jun 2023 – Present",
    description:
      "Founded and led a software development initiative focused on building tailored digital solutions for clients.",
  },
  {
    role: "Supporting Staff",
    company: "Institut Digital Ekonomi LPKIA – Bandung, Indonesia",
    companyUrl: "https://lpkia.ac.id/",
    date: "Jun 2023 – Aug 2024",
    description:
      "Supported academic programs through social media management, content creation, administration, and website development.",
  },
];

const Experience = () => {
  return (
    <section id="experience" className="py-24 px-6 md:px-20 bg-background text-primary relative">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <h2 className="text-sm font-semibold tracking-widest text-muted uppercase mb-2">02. Experience</h2>
          <div className="w-12 h-1 bg-accent/50 rounded-full mb-8"></div>
          <h3 className="text-3xl md:text-4xl font-bold leading-tight tracking-tight">
            Professional <span className="text-accent font-medium">Journey</span>.
          </h3>
        </motion.div>

        <div className="space-y-6">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative p-6 md:p-8 rounded-3xl bg-surface/30 border border-white/5 hover:border-white/10 transition-colors backdrop-blur-sm"
            >
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4">
                <div>
                  <h4 className="text-xl font-semibold text-primary mb-1">
                    {exp.role}
                  </h4>
                  <a
                    href={exp.companyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted hover:text-accent transition-colors text-sm"
                  >
                    {exp.company}
                  </a>
                </div>
                <div className="inline-flex items-center px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium text-muted whitespace-nowrap self-start">
                  {exp.date}
                </div>
              </div>
              <div className="text-muted/80 text-sm md:text-base leading-relaxed">
                {Array.isArray(exp.description) ? (
                  <ul className="list-disc pl-4 space-y-1.5 marker:text-accent/70">
                    {exp.description.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{exp.description}</p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
